import styled from "styled-components";
import { useNavigate } from "react-router-dom";
import { ProjectsContext } from "providers/ProjectsProvider";
import { TasksContext } from "providers/TasksProvider";

import { Topbar } from "components/ui/shared/Topbar"
import { Button } from "components/ui/controls/Button"
import { useContext, useState } from "react";
import { SearchBar } from "components/ui/inputs/SearchBar";
import { DropdownMenu, DropdownOption } from "components/ui/inputs/DropdownMenu";
import { ViewSwitch } from "components/ui/controls/ViewSwitch";
import { DragDropProvider } from "@dnd-kit/react";
import { ArchiveDropZone } from "components/ui/controls/ArchiveDropZone";
import { TaskSettings } from "./TaskSettings";
import { useErrors } from "providers/ErrorsProvider";
import { TasksKanban } from "components/features/tasks/TasksKanban";
import { TasksTimeline } from "components/features/tasks/TasksTimeline";
import { tasksDragHandler } from "utilities/dragAndDropHandlers";
import { MaterialIcon } from "components/ui/shared/MaterialIcon";
export const Tasks = () => {

    const navigate = useNavigate();

    const [tasksView, setTasksView] = useState(() => {return localStorage.getItem("tasksViewStyle") || 'grid'});
    const [tasksFilter, setTasksFilter ] = useState({search: '', priority: null});
    const [isDraggingActive, setIsDraggingActive] = useState(false);

    const { projects } = useContext(ProjectsContext);
    const { tasks, handleTasksEdit } = useContext(TasksContext);

    const { setError } = useErrors();

    const onDragStart = (e) => {
        setIsDraggingActive(true);
    }

    const onDragEnd = async (e) => {

        const res = await tasksDragHandler(e, handleTasksEdit);
        if(res?.status) setError(res.reason);

        setIsDraggingActive(false);
    }

    const filterTasks = () => {
        let tsks = tasks.map(tsk => {
            let searchFilter = true;
            let priorityFilter = true;

            if(!tsk.taskTitle.includes(tasksFilter.search)) searchFilter = false;

            if(tasksFilter.priority)
            {
                if(Number(tsk.taskPriority) !== Number(tasksFilter.priority)) priorityFilter = false;
            }

            if(searchFilter && priorityFilter) return tsk;
            else return null;
        });
        return tsks;
    }
   
    return (
        <>
            <Topbar breacrumb={['Oppgaver']}>
                <Button
                    type='primary'
                    text="Ny oppgave"
                    prefix={<MaterialIcon name='add' weight={300}/>}
                    onClick={() => navigate('/tasks/new')}
                />
            </Topbar>
            <StyledTasksContainer>
                <div className="tasksHeader">
                    <span className="title">
                        Oppgaveoversikt
                    </span>
                    <div className="options">
                        <div>
                            <SearchBar
                                placeholder='Søk i oppgaver...'
                                onChange={(e) => setTasksFilter(prev => ({...prev, search: e.target.value.trim()}))}
                            />

                            <DropdownMenu
                                defaultName="Prioritet"
                                defaultIcon={<MaterialIcon name='flag' weight={300}/>}
                                defaultValue={null}
                                onSelect={(e) => setTasksFilter(prev => ({...prev, priority: e ? e : null}))}
                            >
                                <DropdownOption
                                    name='Lav'
                                    value={1}
                                    icon={<MaterialIcon name='flag' weight={300} color={({theme}) => theme.colors.successForeground}/>}
                                />
                                <DropdownOption
                                    name='Moderat'
                                    value={2}
                                    icon={<MaterialIcon name='flag' weight={300} color={({theme}) => theme.colors.warningForeground}/>}
                                />
                                <DropdownOption
                                    name='Høy'
                                    value={3}
                                    icon={<MaterialIcon name='flag' weight={300} color={({theme}) => theme.colors.errorForeground}/>}
                                />
                                <DropdownOption
                                    name='Tøm filter'
                                    value={null}
                                    icon={<MaterialIcon name='close' weight={300}/>}
                                />
                            </DropdownMenu>
                        </div>
                        <div>
                            <ViewSwitch
                                firstOptionName="Fliser"
                                firstOptionIcon={<MaterialIcon name='grid_view' weight={300}/>}
                                firstOptionValue="grid"

                                secondOptionName="Liste"
                                secondOptionIcon={<MaterialIcon name='list' weight={300}/>}
                                secondOptionValue="list"

                                selected={tasksView}
                                onChange={(e) => {setTasksView(e); localStorage.setItem("tasksViewStyle", e)}}
                            />
                        </div>
                    </div>
                </div>
                <div className="tasksContent">
                    <DragDropProvider onDragStart={onDragStart} onDragEnd={onDragEnd}>
                        {
                            tasksView === 'grid'
                            ? <TasksKanban tasks={filterTasks()} projects={projects}/>
                            : <TasksTimeline tasks={filterTasks()} projects={projects}/>
                        }
                        <ArchiveDropZone isActive={isDraggingActive}/>
                    </DragDropProvider>
                </div>
            </StyledTasksContainer>
            <TaskSettings/>
        </>
    )
}

const StyledTasksContainer = styled.div`
    padding-left: ${({theme}) => theme.spacing.xl};
    padding-right: ${({theme}) => theme.spacing.xl};
    flex: 1 1 auto;
    display: flex;
    flex-direction: column;
    overflow: hidden;

    div.tasksHeader 
    {
        margin-bottom: ${({theme}) => theme.spacing.lg};

        span.title
        {
            font-size: ${({theme}) => theme.fontSize.xxl};
            font-weight: 500;
            display: block;
            margin-bottom: ${({theme}) => theme.spacing.lg};
        }

        div.options
        {
            display: flex;
            flex-direction: row;
            justify-content: space-between;
            align-items: center;
            gap: ${({theme}) => theme.spacing.md};
            

            > div
            {
                display: flex;
                gap: ${({theme}) => theme.spacing.md};
            }
        }
    }

    div.tasksContent
    {
        flex: 1 1 auto;
        overflow: hidden;
    }
`
